export { cookieStorageAdapter } from "./cookie";
export { localStorageAdapter } from "./local-storage";
export { sessionStorageAdapter } from "./session-storage";

export const DEFAULT_STORAGE_KEY = "@nangazaki/vue-rbac:storage"